import { render, staticRenderFns } from "./ScenarioHistoryTranscription.vue?vue&type=template&id=4c05f985&scoped=true&"
import script from "./ScenarioHistoryTranscription.vue?vue&type=script&lang=js&"
export * from "./ScenarioHistoryTranscription.vue?vue&type=script&lang=js&"
import style0 from "./ScenarioHistoryTranscription.vue?vue&type=style&index=0&id=4c05f985&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c05f985",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
